import React, { useEffect, useState,useRef } from "react";
import "./CombinedFilterModal.css";

import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  TextField,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  InputAdornment,
  Tooltip,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SearchIcon from "@mui/icons-material/Search";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import TuneIcon from "@mui/icons-material/Tune";

import MultiSelectDropdown from "../../../EnhanceFilters/MultiSelectDropdown";

import {
  priorities,
  coders,
  files,
  diagnosis,
  drgs,
  speciality,
} from "../../../EnhanceFilters/dummyData";
import {
  getAuditRuleRefNo,
  getCoderName,
  getDrg,
  getEpisodeIdentifiers,
  getFileNames,
  getPredictedDRG1,
  getPredictedDRG2,
  getPrincipalDiagnosis,
  getPrincipalProcedureCodes,
  getSpecialitiesFilter,
  REQUEST_STATUS,
} from "../../../EnhanceFilters/EnhanceFiltersSlice";
import { useDispatch, useSelector } from "react-redux";
import { setPayload } from "../CombinedReviewSlice";
import { formatDate } from "../../../GenericTable/ColumnFilter";
import FilterBreadcrumbs, { FILTER_LABELS } from "../../../GenericTable/FilterBreadcrumbs";
import { getAssignUserMenuData } from "../../../workflowActions/WorkflowSiderbarSlice";

const optimisationLevels = ["High", "Ultra High"];
const procedureCodes = ["P001", "P002", "P003", "P004"];
const auditFlaggedStatuses = [
  "true",
  "false",
];

const initialState = {
  priority: [],
  optimisation: "",
  episode: [],
  codername: [],
  file: [],
  specialities: [],
  actualDrg: [],
  predictedDrg1: [],
  predictedDrg2: [],
  principalDiagnosis: [],
  principalProcedureCode: [],
  admissionFrom: "",
  admissionTo: "",
  separationFrom: "",
  separationTo: "",
  flaggedStatus: [],
  auditRuleReferenceNo: [],
  assignedTo: [],
};

const FieldLabel = ({ children}) => (
  <Typography className="enhance-filter-combined-field-label">
    {children}
  </Typography>
);

const CombinedFilterModal = ({ open, onClose,isUnassignedView, isRecalledView  }) => {
  const [filters, setFilters] = useState(initialState);
  const prevOpenRef = React.useRef(false);
const fileNameToHeaderIdsRef = React.useRef({});
  const [dropdownState, setDropdownState] = useState({
    episode: { page: 1, search: "" },
    file: { page: 1, search: "" },
    specialities: { page: 1, search: "" },
    drg: { page: 1, search: "" },
    principalDiagnosis: { page: 1, search: "" },
    procedure: { page: 1, search: "" },
    codername: { page: 1, search: "" },
    auditRuleReferenceNo: { page: 1, search: "" },
    principalProcedureCodes: { page: 1, search: "" },
    predictedDrg1:{page:1,search:""},
    predictedDrg2:{page:1,search:""}
  });
  const dropdowns = useSelector((state) => state.enhanceFilters.dropdowns);
  const currentPayload = useSelector((state) =>state.combinedReview.payload)
  // console.log(currentPayload,"kkkhgyhuh")
  const dispatch = useDispatch();
  const {
    episode,
    file,
    specialities,
    codername,
    principalDiagnosis,
    drg,
    auditRuleReferenceNo,
    principalProcedureCodes,
    predictedDrg1,
    predictedDrg2
  } = dropdowns;

  // Determine if "to" date fields should be disabled
  const isAdmissionToDisabled = !filters.admissionFrom;
  const isSeparationToDisabled = !filters.separationFrom;
    const assignedToState = useSelector(
    (state) => state.workflowsidebar?.files
  ) ?? { data: [], hasMore: true, status: REQUEST_STATUS.IDLE, error: null };
  
  const [assignedToQuery, setAssignedToQuery] = useState({ page: 1, search: "" });
  
  const assignedToNameToIdRef = useRef({});
  const assignedToIdToNameRef = useRef({});
  
  useEffect(() => {
    if (assignedToState?.data?.length) {
      assignedToState.data.forEach((u) => {
        assignedToNameToIdRef.current[u.username] = u.user_id;
        assignedToIdToNameRef.current[u.user_id] = u.username;
      });
    }
  }, [assignedToState?.data]);

  const loadDropdown = (key, thunk) => {
    setDropdownState((prev) => ({
      ...prev,
      [key]: {
        page: 1,
        search: "",
      },
    }));

    dispatch(
      thunk({
        search: "",
        page_number: 1,
        page_size: 10,
      }),
    );
  };
  useEffect(() => {
    if (!open) return;

    loadDropdown("episode", getEpisodeIdentifiers);
    loadDropdown("file", getFileNames);
    loadDropdown("specialities", getSpecialitiesFilter);
    loadDropdown("codername", getCoderName);
    loadDropdown("drg", getDrg);
    loadDropdown("predictedDrg1", getPredictedDRG1);
    loadDropdown("predictedDrg2", getPredictedDRG2);
    loadDropdown("principalDiagnosis", getPrincipalDiagnosis);
    loadDropdown("auditRuleReferenceNo", getAuditRuleRefNo);
    loadDropdown("principalProcedureCodes", getPrincipalProcedureCodes);
    setAssignedToQuery({ page: 1, search: "" });
    dispatch(getAssignUserMenuData({ pageNumber: 1, search: "" }));
  }, [open]);

  const handleSearch = (key, thunk) => (_, value) => {
    setDropdownState((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        search: value,
        page: 1,
      },
    }));

    dispatch(
      thunk({
        search: value,
        page_number: 1,
        page_size: 10,
      }),
    );
  };
  const handleLoadMore = (key, thunk, hasMore) => () => {
    if (!hasMore) return;

    const nextPage = dropdownState[key].page + 1;

    dispatch(
      thunk({
        search: dropdownState[key].search,
        page_number: nextPage,
        page_size: 10,
      }),
    );

    setDropdownState((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        page: nextPage,
      },
    }));
  };

  const handleInput = (name, value) => {
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleClear = () => {
    setFilters(initialState);
  };
  useEffect(() => {
  const justOpened = open && !prevOpenRef.current;
  prevOpenRef.current = open;

  if (!justOpened) return;
    setFilters({
    priority: (currentPayload.priority || []).map(item => `P${item}`),
    optimisation:
      currentPayload.pallas_priority?.[0],
      episode: currentPayload.episode_identifier || [],
    // codername: (currentPayload.coder_name || []).map((id) => codername.data.find((c) => c.user_id === id)?.username),
    codername: currentPayload.username ,
   file: currentPayload.file_name || [],
    specialities: currentPayload.speciality || [],
    actualDrg: currentPayload.actual_drg || [],
    predictedDrg1: currentPayload.predicted_drg1 || [],
    predictedDrg2: currentPayload.predicted_drg2 || [],
     principalDiagnosis: currentPayload.principal_diagnosis || [],
    principalProcedureCode: currentPayload.procedure_code || [],
     admissionFrom: formatDate(currentPayload.admission_date_from) || "",
    admissionTo: formatDate(currentPayload.admission_date_to) || "",
    separationFrom: formatDate(currentPayload.discharge_date_from) || "",
    separationTo: formatDate(currentPayload.discharge_date_to) || "",
    flaggedStatus: currentPayload.flagged_status.map((item) =>item === "true") || [],
    auditRuleReferenceNo: currentPayload.audit_rule_ref_no || [],
    assignedTo: (currentPayload.assigned_to || []).map(
      (id) => assignedToIdToNameRef.current[id] || id
    ),
  });
}, [open, currentPayload]);

useEffect(() => {
  if (file?.data?.length) {
    file.data.forEach((f) => {
      if (!fileNameToHeaderIdsRef.current[f.file_name]) {
        fileNameToHeaderIdsRef.current[f.file_name] = new Set();
      }
      fileNameToHeaderIdsRef.current[f.file_name].add(f.header_id);
    });
  }
}, [file?.data]);

const getModalOwnedIds = () => {
  const s = new Set();
  Object.values(fileNameToHeaderIdsRef.current).forEach((set) =>
    set.forEach((id) => s.add(id)),
  );
  return s;
};
const getModalOwnedNames = () => new Set(Object.keys(fileNameToHeaderIdsRef.current));

const handleApply = () => {
  let pallasPriority = [];
  if (filters.optimisation === "Ultra High") {
    pallasPriority = ["Ultra High"];
  } else if (filters.optimisation === "High") {
    pallasPriority = ["High"];
  }

  const modalOwnedIds = getModalOwnedIds();
  const modalOwnedNames = getModalOwnedNames();

  // preserve ids/names this modal's own dropdown never produced
  // (i.e. set by the toolbar's "Select Files" menu)
  const preservedHeaderIds = (currentPayload.header_id || []).filter(
    (id) => !modalOwnedIds.has(id),
  );
  const preservedFileNames = (currentPayload.file_name || []).filter(
    (name) => !modalOwnedNames.has(name),
  );

  const selectedHeaderIds = Array.from(
    new Set(
      filters.file.flatMap(
        (name) => Array.from(fileNameToHeaderIdsRef.current[name] || []),
      ),
    ),
  );
  const selectedAssignedToIds = filters.assignedTo
    .map((name) => assignedToNameToIdRef.current[name])
    .filter((id) => id !== undefined);

  dispatch(
    setPayload({
      pallas_priority: pallasPriority,
      priority: filters.priority.map((item) =>
        Number(String(item).replace("P", ""))
      ),
      episode_identifier: filters.episode,
      coder_name: filters.codername,

      file_name: Array.from(new Set([...preservedFileNames, ...filters.file])),
      header_id: Array.from(new Set([...preservedHeaderIds, ...selectedHeaderIds])),

      speciality: filters.specialities,
      actual_drg: filters.actualDrg,
      predicted_drg1: filters.predictedDrg1,
      predicted_drg2: filters.predictedDrg2,
      principal_diagnosis: filters.principalDiagnosis,
      procedure_code: filters.principalProcedureCode,
      admission_date_from: formatDate(filters.admissionFrom),
      admission_date_to: formatDate(filters.admissionTo),
      discharge_date_from: formatDate(filters.separationFrom),
      discharge_date_to: formatDate(filters.separationTo),
      audit_rule_ref_no: filters.auditRuleReferenceNo,
      flagged_status: filters.flaggedStatus.map((item) => item === "true"),
      page_number: 1,
      unassigned_page: isUnassignedView,
      is_flagged: isRecalledView,
      recall: isRecalledView,
       assigned_to: selectedAssignedToIds,

    }),
  );

  onClose();
};
  const handleAssignedToSearch = (_, value) => {
  setAssignedToQuery({ search: value, page: 1 });
  dispatch(getAssignUserMenuData({ pageNumber: 1, search: value }));
};

const handleAssignedToLoadMore = () => {
  if (!assignedToState.hasMore) return;
  const nextPage = assignedToQuery.page + 1;
  dispatch(getAssignUserMenuData({ pageNumber: nextPage, search: assignedToQuery.search }));
  setAssignedToQuery((prev) => ({ ...prev, page: nextPage }));
};

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        // Only close when explicitly triggered (like clicking the X button)
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          return;
        }
        onClose();
      }}
      fullWidth
      maxWidth="md"
      classes={{ paper: "enhance-filter-combined-modal" }}
      slotProps={{
        backdrop: {
          sx: { backgroundColor: "rgba(0,0,0,0.5)" },
        },
      }}
    >
      <Box className="enhance-filter-combined-header">
        <Box>
          <Typography className="enhance-filter-combined-title">
            Filter Records
          </Typography>
          <Typography className="enhance-filter-combined-subtitle">
            Refine the combined review workspace.
          </Typography>
          <Box mt={1}>
            <FilterBreadcrumbs
              filters={filters}
              labels={FILTER_LABELS}
              onRemove={(key, value) => {
                setFilters((prev) => ({
                  ...prev,
                  [key]: Array.isArray(prev[key])
                    ? prev[key].filter((item) => item !== value)
                    : "",
                }));
              }}
            />
          </Box>
        </Box>

        <IconButton size="small" onClick={onClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>

      <DialogContent className="enhance-filter-combined-body">
        <Box className="enhance-filter-combined-scroll-area">
          <Box className="enhance-filter-combined-row enhance-filter-combined-row-2">
            <Box className="enhance-filter-combined-field">
              <Typography className="enhance-filter-combined-section-heading-first">
                SELECT PRIORITY
              </Typography>
              <MultiSelectDropdown
                placeholder="All Priorities"
                options={priorities}
                value={filters.priority}
                onChange={(value) => handleInput("priority", value)}
              />
            </Box>

            <Box className="enhance-filter-combined-field">
              <Typography className="enhance-filter-combined-section-heading-first">
                E+ OPTIMISATION
              </Typography>
              <Box className="enhance-filter-combined-optimisation-group">
                {optimisationLevels.map((level) => (
                  <button
                    type="button"
                    key={level}
                    className={`enhance-filter-combined-optimisation-btn ${
                      filters.optimisation === level
                        ? "enhance-filter-combined-optimisation-active"
                        : ""
                    }`}
                    onClick={() => handleInput("optimisation", level)}
                  >
                    {level}
                  </button>
                ))}
              </Box>
            </Box>
          </Box>

          <Typography className="enhance-filter-combined-section-heading">
            EPISODE FILTERS
          </Typography>

          <Box className="enhance-filter-combined-row enhance-filter-combined-row-4">
            <Box className="enhance-filter-combined-field">
              <MultiSelectDropdown
                label="Episode Identifier"
                placeholder="Search Episode"
                options={episode.data}
                value={filters.episode}
                onChange={(value) => handleInput("episode", value)}
                loading={
                  episode.status === REQUEST_STATUS.LOADING &&
                  dropdownState.episode.page === 1
                }
                loadingMore={
                  episode.status === REQUEST_STATUS.LOADING &&
                  dropdownState.episode.page > 1
                }
                hasMore={episode.hasMore}
                onLoadMore={handleLoadMore(
                  "episode",
                  getEpisodeIdentifiers,
                  episode.hasMore,
                )}
                onInputChange={handleSearch("episode", getEpisodeIdentifiers)}
              />
            </Box>

            <MultiSelectDropdown
              label="Coder Name"
              placeholder="Search Coders"
              options={codername.data.map((c) => c.username)}
              value={filters.codername}
              onChange={(value) => handleInput("codername", value)}
              loading={
                codername.status === REQUEST_STATUS.LOADING &&
                dropdownState.codername.page === 1
              }
              loadingMore={
                codername.status === REQUEST_STATUS.LOADING &&
                dropdownState.codername.page > 1
              }
              hasMore={codername.hasMore}
              onLoadMore={handleLoadMore(
                "codername",
                getCoderName,
                codername.hasMore,
              )}
              onInputChange={handleSearch("codername", getCoderName)}
            />
            <MultiSelectDropdown
              label="Assigned To"
              placeholder="Search Users"
              options={assignedToState.data.map((u) => u.username)}
              value={filters.assignedTo}
              onChange={(value) => handleInput("assignedTo", value)}
              loading={
                assignedToState.status === REQUEST_STATUS.LOADING &&
                assignedToQuery.page === 1
              }
              loadingMore={
                assignedToState.status === REQUEST_STATUS.LOADING &&
                assignedToQuery.page > 1
              }
              hasMore={assignedToState.hasMore}
              onLoadMore={handleAssignedToLoadMore}
              onInputChange={handleAssignedToSearch}
            />

            <MultiSelectDropdown
              label="File Name"
              placeholder="Search File"
              options={[...new Set(file.data.map((f) => f.file_name))]}
              value={filters.file}
              onChange={(value) => handleInput("file", value)}
              loadingMore={
                file.status === REQUEST_STATUS.LOADING &&
                dropdownState.file.page > 1
              }
              hasMore={file.hasMore}
              onLoadMore={handleLoadMore("file", getFileNames, file.hasMore)}
              onInputChange={handleSearch("file", getFileNames)}
            />

            <MultiSelectDropdown
              label="Speciality"
              placeholder="Search Speciality"
              options={specialities.data}
              value={filters.specialities}
              onChange={(value) => handleInput("specialities", value)}
              loading={
                specialities.status === REQUEST_STATUS.LOADING &&
                dropdownState.specialities.page === 1
              }
              loadingMore={
                specialities.status === REQUEST_STATUS.LOADING &&
                dropdownState.specialities.page > 1
              }
              onLoadMore={handleLoadMore(
                "specialities",
                getSpecialitiesFilter,
                specialities.hasMore,
              )}
              onInputChange={handleSearch(
                "specialities",
                getSpecialitiesFilter,
              )}
            />
          </Box>

          <Typography className="enhance-filter-combined-section-heading">
            DRG FILTERS
          </Typography>

          <Box className="enhance-filter-combined-row enhance-filter-combined-row-3">
            <MultiSelectDropdown
              label="Actual DRG"
              placeholder="Search DRG..."
              options={drg.data}
              value={filters.actualDrg}
              onChange={(v) => handleInput("actualDrg", v)}
              loading={
                drg.status === REQUEST_STATUS.LOADING &&
                dropdownState.drg.page === 1
              }
              loadingMore={
                drg.status === REQUEST_STATUS.LOADING &&
                dropdownState.drg.page > 1
              }
              hasMore={drg.hasMore}
              onLoadMore={handleLoadMore("drg", getDrg, drg.hasMore)}
              onInputChange={handleSearch("drg", getDrg)}
            />

            <MultiSelectDropdown
              label="Predicted DRG 1"
              placeholder="Search DRG"
              options={predictedDrg1.data}
              value={filters.predictedDrg1}
              onChange={(value) => handleInput("predictedDrg1", value)}
              loading={
                predictedDrg1.status === REQUEST_STATUS.LOADING &&
                dropdownState.predictedDrg1.page === 1
              }
              loadingMore={
                predictedDrg1.status === REQUEST_STATUS.LOADING &&
                dropdownState.predictedDrg1.page > 1
              }
              hasMore={predictedDrg1.hasMore}
              onLoadMore={handleLoadMore(
                "predictedDrg1",
                getPredictedDRG1,
                predictedDrg1.hasMore,
              )}
              onInputChange={handleSearch("predictedDrg1", getPredictedDRG1)}
            />

            <MultiSelectDropdown
              label="Predicted DRG 2"
              placeholder="Search DRG"
              options={predictedDrg2.data}
              value={filters.predictedDrg2}
              onChange={(value) => handleInput("predictedDrg2", value)}
              loading={
                predictedDrg2.status === REQUEST_STATUS.LOADING &&
                dropdownState.predictedDrg2.page === 1
              }
              loadingMore={
                predictedDrg2.status === REQUEST_STATUS.LOADING &&
                dropdownState.predictedDrg2.page > 1
              }
              hasMore={predictedDrg2.hasMore}
              onLoadMore={handleLoadMore(
                "predictedDrg2",
                getPredictedDRG2,
                predictedDrg2.hasMore,
              )}
              onInputChange={handleSearch("predictedDrg2", getPredictedDRG2)}
            />
          </Box>

          <Typography className="enhance-filter-combined-section-heading">
            CLINICAL FILTERS
          </Typography>

          <Box className="enhance-filter-combined-row enhance-filter-combined-row-2">
            <MultiSelectDropdown
              label="Principal Diagnosis"
              placeholder="Search Diagnosis"
              options={principalDiagnosis.data}
              value={filters.principalDiagnosis}
              onChange={(value) => handleInput("principalDiagnosis", value)}
              loading={
                principalDiagnosis.status === REQUEST_STATUS.LOADING &&
                dropdownState.principalDiagnosis.page === 1
              }
              loadingMore={
                principalDiagnosis.status === REQUEST_STATUS.LOADING &&
                dropdownState.principalDiagnosis.page > 1
              }
              hasMore={principalDiagnosis.hasMore}
              onLoadMore={handleLoadMore(
                "principalDiagnosis",
                getPrincipalDiagnosis,
                principalDiagnosis.hasMore,
              )}
              onInputChange={handleSearch(
                "principalDiagnosis",
                getPrincipalDiagnosis,
              )}
            />

            <MultiSelectDropdown
              label="Principal Procedure Code"
              placeholder="Search Procedure Code..."
              options={principalProcedureCodes.data}
              value={filters.principalProcedureCode}
              onChange={(value) => handleInput("principalProcedureCode", value)}
              loading={
                principalProcedureCodes.status === REQUEST_STATUS.LOADING &&
                dropdownState.principalProcedureCodes.page === 1
              }
              loadingMore={
                principalProcedureCodes.status === REQUEST_STATUS.LOADING &&
                dropdownState.principalProcedureCodes.page > 1
              }
              hasMore={principalProcedureCodes.hasMore}
              onLoadMore={handleLoadMore(
                "principalProcedureCodes",
                getPrincipalProcedureCodes,
                principalProcedureCodes.hasMore,
              )}
              onInputChange={handleSearch(
                "principalProcedureCodes",
                getPrincipalProcedureCodes,
              )}
            />
          </Box>

          <Typography className="enhance-filter-combined-section-heading">
            DATE FILTERS
          </Typography>

          <Box className="enhance-filter-combined-row enhance-filter-combined-row-2">
            <Box className="enhance-filter-combined-date-group">
              <FieldLabel>Admission Date</FieldLabel>
              <Box className="enhance-filter-combined-date-group-inputs">
                {/* Admission From - No Tooltip */}
                <TextField
                  type="date"
                  value={filters.admissionFrom}
                  onChange={(e) => handleInput("admissionFrom", e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  InputProps={{ notched: false }}
                  fullWidth
                />
                <Typography className="enhance-filter-combined-date-group-to">
                  to
                </Typography>
                {/* Admission To - Tooltip only when disabled */}
                <Tooltip
                  title={
                    isAdmissionToDisabled
                      ? "Please select a 'From' date first"
                      : ""
                  }
                  arrow
                  disableHoverListener={!isAdmissionToDisabled}
                >
                  <span style={{ width: "100%" }}>
                    <TextField
                      type="date"
                      value={filters.admissionTo}
                      onChange={(e) =>
                        handleInput("admissionTo", e.target.value)
                      }
                      InputLabelProps={{ shrink: true }}
                      InputProps={{
                        notched: false,
                        inputProps: {
                          min: filters.admissionFrom || undefined,
                        },
                      }}
                      disabled={isAdmissionToDisabled}
                      fullWidth
                      sx={{
                        "& .MuiInputBase-root.Mui-disabled": {
                          backgroundColor: "#f5f5f5",
                          cursor: "not-allowed",
                        },
                      }}
                    />
                  </span>
                </Tooltip>
              </Box>
            </Box>

            <Box className="enhance-filter-combined-date-group">
              <FieldLabel>Separation Date</FieldLabel>
              <Box className="enhance-filter-combined-date-group-inputs">
                {/* Separation From - No Tooltip */}
                <TextField
                  type="date"
                  value={filters.separationFrom}
                  onChange={(e) =>
                    handleInput("separationFrom", e.target.value)
                  }
                  InputLabelProps={{ shrink: true }}
                  InputProps={{ notched: false }}
                  fullWidth
                />
                <Typography className="enhance-filter-combined-date-group-to">
                  to
                </Typography>
                {/* Separation To - Tooltip only when disabled */}
                <Tooltip
                  title={
                    isSeparationToDisabled
                      ? "Please select a 'From' date first"
                      : ""
                  }
                  arrow
                  disableHoverListener={!isSeparationToDisabled}
                >
                  <span style={{ width: "100%" }}>
                    <TextField
                      type="date"
                      value={filters.separationTo}
                      onChange={(e) =>
                        handleInput("separationTo", e.target.value)
                      }
                      InputLabelProps={{ shrink: true }}
                      InputProps={{
                        notched: false,
                        inputProps: {
                          min: filters.separationFrom || undefined,
                        },
                      }}
                      disabled={isSeparationToDisabled}
                      fullWidth
                      sx={{
                        "& .MuiInputBase-root.Mui-disabled": {
                          backgroundColor: "#f5f5f5",
                          cursor: "not-allowed",
                        },
                      }}
                    />
                  </span>
                </Tooltip>
              </Box>
            </Box>
          </Box>

          <Accordion
            defaultExpanded
            className="enhance-filter-combined-advanced"
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon fontSize="small" />}>
              <Box display="flex" alignItems="center" gap={1}>
                <TuneIcon fontSize="small" />
                <Typography className="enhance-filter-combined-advanced-title">
                  Advanced Filters
                </Typography>
              </Box>
            </AccordionSummary>

            <AccordionDetails>
              <Box className="enhance-filter-combined-row enhance-filter-combined-row-2">
                <Box className="enhance-filter-combined-field">
                  <MultiSelectDropdown
                    label="Audit Rule Reference No"
                    placeholder="Search Reference No"
                    options={auditRuleReferenceNo.data}
                    value={filters.auditRuleReferenceNo}
                    onChange={(value) =>
                      handleInput("auditRuleReferenceNo", value)
                    }
                    loading={
                      auditRuleReferenceNo.status === REQUEST_STATUS.LOADING &&
                      dropdownState.episode.page === 1
                    }
                    loadingMore={
                      auditRuleReferenceNo.status === REQUEST_STATUS.LOADING &&
                      dropdownState.auditRuleReferenceNo.page > 1
                    }
                    hasMore={auditRuleReferenceNo.hasMore}
                    onLoadMore={handleLoadMore(
                      "auditRuleReferenceNo",
                      getAuditRuleRefNo,
                      auditRuleReferenceNo.hasMore,
                    )}
                    onInputChange={handleSearch(
                      "auditRuleReferenceNo",
                      getAuditRuleRefNo,
                    )}
                  />
                </Box>

                <MultiSelectDropdown
                  label="Flagged Status"
                  placeholder="All Statuses"
                  options={auditFlaggedStatuses}
                  value={filters.flaggedStatus}
                  onChange={(value) => handleInput("flaggedStatus", value)}
                />
              </Box>
            </AccordionDetails>
          </Accordion>
        </Box>

        <Box className="enhance-filter-combined-footer">
          <Button
            size="small"
            startIcon={<RestartAltIcon fontSize="small" />}
            color="error"
            onClick={handleClear}
          >
            Clear All
          </Button>

          <Box display="flex" gap={1.5}>
            <Button size="small" variant="outlined" onClick={onClose}>
              Cancel
            </Button>

            <Button
              size="small"
              variant="contained"
              className="enhance-filter-combined-apply-btn"
              onClick={handleApply}
            >
              Apply Filters
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default CombinedFilterModal;